import { UsersThree } from "@phosphor-icons/react";

const HEAVY = ["Over 50%", "Over 75%", "100%"];

/* Amber flag for suppliers who outsource most of their work to subcontractors. */
export default function SubcontractorBadge({ supplier, compact = false }) {
  if (supplier?.uses_subcontractors !== "Yes" || !HEAVY.includes(supplier?.subcontractor_percentage)) return null;
  const pct = supplier.subcontractor_percentage;
  const vetted = supplier.subcontractors_vetted;
  const tooltip = `Outsources ${pct.toLowerCase()} of work to subcontractors${vetted ? ` — fully vetted: ${vetted}` : ""}`;
  return (
    <span
      title={tooltip}
      className={`inline-flex items-center gap-1 rounded font-semibold ${compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]"} ${pct === "100%" ? "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300" : "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300"}`}
      data-testid={`subcontractor-badge-${supplier.id}`}
    >
      <UsersThree size={compact ? 10 : 12} weight="fill" />
      Subs {pct}
      {vetted === "No" && <span className="opacity-80">· unvetted</span>}
    </span>
  );
}
